module.exports = __webpack_public_path__ + "img/stepicons-housevisit.106ca38d.svg";